import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { UnauthenticatedRoutes } from '@/router/routes';

export const ExpiredLinkMessage: React.FC = () => {
  const { t } = useTranslation('unauthenticated.accountActivation');
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-sm">
      <h1 className="text-2xl font-semibold text-foreground">{t('expiredHeader')}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t('expiredSubtitle')}</p>
      <Button
        variant="outline"
        onClick={() => navigate(UnauthenticatedRoutes.Login)}
        className="mt-6"
      >
        {t('backToLogin')}
      </Button>
    </div>
  );
};
